import { render, staticRenderFns } from "./MyAccountGeneralData.vue?vue&type=template&id=bae68aca&"
import script from "./MyAccountGeneralData.vue?vue&type=script&lang=js&"
export * from "./MyAccountGeneralData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports